import _ from 'lodash';
import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import Menu from '@/components/Menu';
import ApiKeys from '@/components/ApiKeys';
import ReassignReports from '@/components/ReassignReports';
import ReclaimEmail from '@/components/ReclaimEmail';
import ManageValueAddedResalers from '@/components/ManageValueAddedResalers';
import Login from '@/components/Login';

Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
    unprotected: true,
  },
  {
    path: '/home',
    name: 'Home',
    component: ApiKeys,
  },
  {
    path: '/menu',
    name: 'Menu',
    component: Menu,
    adminOnly: true,
  },
  {
    path: '/reassign_reports',
    name: 'ReassignReports',
    component: ReassignReports,
    adminOnly: true,
  },
  {
    path: '/reclaim_email',
    name: 'ReclaimEmail',
    component: ReclaimEmail,
    adminOnly: true,
  },
  {
    path: '/manage_var',
    name: 'ManageValueAddedResalers',
    component: ManageValueAddedResalers,
    adminOnly: true,
  },
];

const router = new Router({
  routes,
});

const UNPROTECTED_ROUTES = _.map(_.filter(routes, 'unprotected'), 'name');
const ADMIN_ROUTES = _.map(_.filter(routes, 'adminOnly'), 'name');
router.beforeEach(async (to, from, next) => {
  if (_.includes(ADMIN_ROUTES, to.name)) {
    await store.state.Login.loginCheckedP;
    if (store.getters['Login/admin']) {
      next();
    } else if (store.getters['Login/loggedIn']) {
      next({ name: 'Home' });
    } else {
      next({ name: 'Login' });
    }
  } else if (_.includes(UNPROTECTED_ROUTES, to.name) || await store.state.Login.loginCheckedP) {
    next();
  } else {
    next({ name: 'Login' });
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js